import ModalInPortal from './Modal';

export default ModalInPortal;
